import { render, staticRenderFns } from "./ProfilePackages.vue?vue&type=template&id=8e112850&"
import script from "./ProfilePackages.vue?vue&type=script&lang=js&"
export * from "./ProfilePackages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports